<template>
  <div>
    <p class="mt0 mb3 f6 lh-copy mid-gray">Please enter your email address and we'll send you an email where you can reset your password.</p>

    <el-alert v-if="authError" type="error" :title="authError" show-icon @close="closeAlert()"></el-alert>
    <el-alert v-if="!showForm" type="success" title="Please check your email for further instructions" show-icon :closable="false"></el-alert>

    <el-form :model="user" :rules="rules" ref="form" @submit.native.prevent="submit()" v-if="showForm">
      <el-form-item label="Email" prop="email">
        <el-input type="email" v-model="user.email"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">Reset password</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      showForm: true,
      user: {},
      rules: {
        email: [
          { required: true, type: 'email', trigger: 'blur' }
        ]
      }

    }
  },

  computed: {
    ...mapState('auth', ['authError'])
  },

  methods: {
    ...mapActions('auth', ['createPasswordReset']),
    ...mapMutations('auth', ['setError']),

    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.createPasswordReset(this.user.email)
            .then(() => this.showForm = false)
            .catch(() => false)
        } else {
          return false;
        }
      })
    },

    closeAlert() {
      this.setError(null)
    }
  }
}
</script>